import React from 'react';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-sand px-5 py-20 sm:py-28" data-id="element-17" data-mp="pjpx9t6ljn8q">
      <div className="mx-auto max-w-2xl" data-id="element-18" data-mp="pj6c83lngiqh">
        <div className="text-center" data-id="element-19" data-mp="avd0itzoq0d6">
          <span className="text-[11px] font-bold uppercase tracking-[0.22em] text-teal" data-id="element-20" data-mp="aua4k7ni97qe">
            Solo per oggi
          </span>
          <h2 className="mt-4 font-display text-[1.75rem] font-black leading-tight tracking-tight text-navy sm:text-[2.4rem]" data-id="element-21" data-mp="frtkdbzupskg">
            <span aria-hidden="true" data-id="element-22" data-mp="5wi4gqcpifb4">🎁 </span>Ricevi i 5 Bonus{' '}
            <span className="italic text-grape" data-id="element-23" data-mp="5tnkezxluwi8">Strategici</span>
          </h2>
          <p className="mt-3 text-sm text-navy/60" data-id="element-24" data-mp="3o3g0c60mldnj">
            Valore totale:{' '}
            <span className="font-bold text-navy/40 line-through" data-id="element-25" data-mp="3t1hjeqy1xcz0">€185</span> —
            Inclusi a <span className="font-bold text-tangerine" data-id="element-26" data-mp="1mb9zlb18m0o4">€0</span> nel
            tuo ordine
          </p>
        </div>

        <ol className="mt-10 space-y-4" data-id="element-27" data-mp="1r8td28q429f0">
          {bonuses.map((bonus, index) => <li key={bonus.title} className="flex items-start gap-4 rounded-2xl bg-white p-5 shadow-[0_2px_10px_-6px_rgba(22,56,111,0.25)]" data-id="element-28" data-mp="3id54x7cwv5bb" data-mpi={index}>
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-tangerine font-display text-sm font-bold text-white" data-id="element-29" data-mp="3r700bno8dhdr">
                {index + 1}
              </span>
              <img src={bonus.cover} alt="" className="h-16 w-12 shrink-0 rounded-md object-cover shadow-[0_2px_8px_-4px_rgba(22,56,111,0.4)]" data-id="element-30" data-mp="2zeslmssacf20" />
              <div data-id="element-31" data-mp="38hbhgsxnlrer">
                <h3 className="font-display text-sm font-bold leading-snug text-navy" data-id="element-32" data-mp="38htlwcugzbxr">
                  {bonus.title}
                </h3>
                <p className="mt-1.5 text-xs leading-relaxed text-navy/60" data-id="element-33" data-mp="nq1dx6xbhgw4">
                  {bonus.text}
                </p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}